import { Component, OnInit, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'artemis-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})

export class PopoverComponent implements OnInit {

  isPopoverOpened: boolean = false;

  @HostListener('document:click', ['$event']) onClick($event: any) {
    if ($event.target !== this.popover.nativeElement && !this.popover.nativeElement.contains($event.target) && this.isPopoverOpened) {
      this.togglePopover();
    }
  }

  constructor(private popover: ElementRef) { }

  ngOnInit() {
  }

  togglePopover(): void {
    this.isPopoverOpened = !this.isPopoverOpened;
  }

}
